import React, { Fragment, useState } from 'react';
import { faBackspace, faMobile, faPhone, faPho, faCut } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal, Button, Row, Input, InputGroupAddon, InputGroup } from 'reactstrap';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
const style = `


  
   .numberpad{
    width: 330px;
  position: absolute;
  top: 50px;
  right:0px;
  background: white;
  z-index: 500;
  border: 1px solid;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;

   }


  
  .dialpad-row {        
    font-family: 'Exo';
    padding: 0.5rem 2rem 0.5rem 2rem;
  }
  
  .digit,
  .dig {           
    font-size: 2rem;
    cursor: pointer;
    text-align:center;
  }
  
  .sub {
    font-size: 0.8rem;
    color: grey;
  }
  

  
  #output {
    font-family: "Exo";
    font-size: 2rem;    
    font-weight: bold;
    color: #1976d2;
  }

  .botrow {
    margin: 0 auto;
    width: 280px;
    clear: both;
    text-align: center;
    font-family: 'Exo';
  }
  
  .digit:active,
  .dig:active {
    background-color: #e6e6e6;
  }
  

  
  .dig {
    float: left;
    padding: 10px 20px;
    margin: 10px;
    width: 30px;
    cursor: pointer;
  }`;

function DialPad({ handlePhoneNumber, toggle, isOnCall, makeCall,
    terminateCall, }) {
    const [number, setNumber] = useState('');

    const handleNumber = (e) => {
        setNumber(number + e);
        handlePhoneNumber(number + e);
    }
    const handleChange = (e) => {
        setNumber(e.target.value);
        handlePhoneNumber(e.target.value);
    }
    return (
        <Fragment>
            <div className='numberpad'>
                <style>{style}</style>
                <button type="button" onClick={toggle} className="close m-2">
                    <span aria-hidden="true">×</span>
                </button>
                <div className='m-2'>
                    <div id="output">
                        <div className='m-3'>
                            <InputGroup>
                                <Input
                                    className="input_sty"
                                    type="text"
                                    placeHolder="Number"
                                    onChange={handleChange}
                                    value={number}
                                />
                                <InputGroupAddon addonType="prepend">

                                </InputGroupAddon>
                            </InputGroup>
                        </div>
                    </div>
                    <div className='mx-3 mb-1'>
                        <div className='d-flex justify-content-between dialpad-row'>
                            <div className="digit" id="one" onClick={() => handleNumber(1)}>1</div>
                            <div className="digit" id="two" onClick={() => handleNumber(2)}>2
                                <div className="sub">ABC</div>
                            </div>
                            <div className="digit" id="three" onClick={() => handleNumber(3)}>3
                                <div className="sub">DEF</div>
                            </div>
                        </div>
                        <div className='d-flex justify-content-between dialpad-row'>
                            <div className="digit" id="four" onClick={() => handleNumber(4)}>4
                                <div className="sub">GHI</div>
                            </div>
                            <div className="digit" id="five" onClick={() => handleNumber(5)}>5
                                <div className="sub">JKL</div>
                            </div>
                            <div className="digit" onClick={() => handleNumber(6)}>6
                                <div className="sub">MNO</div>
                            </div>
                        </div>
                        <div className='d-flex justify-content-between dialpad-row'>
                            <div className="digit" onClick={() => handleNumber(7)}>7
                                <div className="sub">PQRS</div>
                            </div>
                            <div className="digit" onClick={() => handleNumber(8)}>8
                                <div className="sub">TUV</div>
                            </div>
                            <div className="digit pl-2" onClick={() => handleNumber(9)}>
                                <span>9</span>
                                <div className="sub">WXYZ</div>
                            </div>
                        </div>
                        <div className='d-flex justify-content-between dialpad-row'>
                            <div className="digit" onClick={() => handleNumber('*')}>*
                            </div>
                            <div className="digit" onClick={() => handleNumber(0)}>0
                            </div>
                            <div className="digit" onClick={() => handleNumber('#')}>#
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </Fragment >
    )
}

export default DialPad;